module.exports = __webpack_public_path__ + "img/annual_certificate_4.bfa13eb4.svg";